import {
    FontPalette,
    FontFiles,
    createTheme,
    ColorPalette,
    Theme,
    DefaultTheme,
} from "@assets/theme/Theme"
import { EncodedImages } from "../images/encodedImages"

// create the default theme

const fontPalette: FontPalette = {
    //
    regular: "polls-OpenSans-Regular",
    semiBold: "polls-OpenSans-SemiBold",
    bold: "polls-OpenSans-Bold",

    pollsRegular: "sf-pro-display",
    pollsSemiBold: "sf-pro-display-semibold",
    pollsBold: "sf-pro-display-bold",
}

const fontFiles: FontFiles = {
    // sf pro font files are always included

    // add custom fonts
    "polls-OpenSans-Regular": require("../fonts/OpenSans-Regular.ttf"),
    "polls-OpenSans-SemiBold": require("../fonts/OpenSans-SemiBold.ttf"),
    "polls-OpenSans-Bold": require("../fonts/OpenSans-Bold.ttf"),

    // set custom icon font, or include default
    // default
    IcoMoon: require("@assets/icons/icomoon.ttf"),

    // custom
    // IcoMoon: require("../icons/icomoon.ttf"),
}

const colorPalette: ColorPalette = {
    // main colors
    primary: "#FEA56B", // main color of the theme used in general
    secondary: "#ebebeb", // accent color

    // backgrounds
    screenBackground: "#0E0E0F", // color of screen on mobile, or poll card on desktop, does not determine backdrop outside the poll card
    cardBackground: "#1C1C20", // all cards, option cards, settings cards, modals, drawers
    overlay: "#000000", // color used behind a mondal to "blur" the background

    // icons
    primaryIcon: "#FEA56B", // e.g. tab bar icons
    secondaryIcon: "#ebebeb", // e.g. re-order, close

    // buttons
    primaryCtaBackground: "#FEA56B",
    primaryCtaBackgroundInactive: "#5C5C5C",
    primaryCtaTextActive: "#FFFFFF",
    primaryCtaTextDisabled: "#FFFFFF",

    secondaryCtaBackground: "#1C1C20",
    secondaryCtaTextActive: "#FEA56B",
    secondaryCtaTextDisabled: "#FFFFFF",

    tertiaryCtaBackground: "#", // tertiary cta (is this floating, or do we have tertiary AND floating)
    tertiaryCtaTextActive: "#",
    tertiaryCtaTextDisabled: "#",

    floatingCTAText: "#FEA56B",
    floatingCTATextDisabled: "#9b9b9b",

    // text
    t1: "#FFFFFF", //all primary text, such as poll title, option card title, etc.
    t2: "#ebebeb", //all secondary text, such as help text, option subtitle, option details
    t3: "#5C5C5C", //help text and option details
    regularText: "#343E57",
    t1Inverted: "#FFFFFF",
    placeholder: "#5C5C5C", //placeholder text before user types poll or option titles
    linkText: "#007AFE",
    error: "#FE281C",

    // misc
    shadow: "#1C1C1C", // color needed for dark shadows
    flag: "#FEA56B", //color to draw attention such as submit to save changes banner
    divider: "#FFFFFF", //divider lines
    banner: "#1C1C20", //banners such as the paste links banner
    destructive: "#FE281C", //for deleting things, typically red
    success: "#05CB4F",

    // Polls Colors (our palette)
    pollPrimaryTextColor: "#343E57",
}

export const TenantTheme = createTheme({
    fontPalette: fontPalette,
    fontFiles: fontFiles,
    colorPalette: colorPalette,
    fontSizeMultiplier: 1.0,
    lineHeightMultiplier: 1.0,
    overrides: {
        // color
        // font
        // shadow
        // cornerRadius
        // image
        // layout
        // lottie

        //old stuff to be removed
        // borderRadius
        // fontFiles

        color: {
            navHeaderBackground: colorPalette.screenBackground,
            optionCardProgressBarFill: colorPalette.flag,
            optionCardProgressBarBackground: "#3E3E3E",
            ctaPrimaryActiveBackground: colorPalette.primaryCtaBackground,
            ctaPrimaryText: colorPalette.primaryCtaTextActive,
            ctaFloatingText: colorPalette.t1,
            optionCardCheckbox: colorPalette.primary,
            checkBox: colorPalette.primary,
            pollListCopyBannerIconBackground: colorPalette.screenBackground,
            shareQrCodeBackground: colorPalette.cardBackground,
            shareQrCodeForeground: colorPalette.t1,
        },

        font: {
            //Poll Title
            pollTitleActiveWeb: {
                ...DefaultTheme.font.pollTitleActiveWeb,
                fontFamily: fontPalette.bold,
                fontSize: 16,
                lineHeight: 25,
                color: colorPalette.t1,
            },

            pollTitleActiveMobile: {
                ...DefaultTheme.font.pollTitleActiveMobile,
                fontFamily: fontPalette.bold,
                fontSize: 20,
                lineHeight: 21,
                color: colorPalette.t1
            },

            // // Option Card
            // optionCardTextVoteCount: {
            //     ...DefaultTheme.font.optionCardTextVoteCount,
            //     fontSize: 12,
            //     lineHeight: 10,
            //     fontFamily: fontPalette.bold,
            // },
            defaultCardTemplateTitle: {
                ...DefaultTheme.font.defaultCardTemplateTitle,
                fontFamily: fontPalette.bold,
                fontSize: 13,
                lineHeight: 18,
                color: colorPalette.t1,
            },
            defaultCardTemplateSubtitle: {
                ...DefaultTheme.font.defaultCardTemplateSubtitle,
                fontFamily: fontPalette.semiBold,
                fontSize: 12,
                lineHeight: 14,
                color: colorPalette.primary,
            },
            defaultCardTemplateDescription: {
                ...DefaultTheme.font.defaultCardTemplateDescription,
                fontFamily: fontPalette.regular,
                fontSize: 10,
                lineHeight: 14,
                color: colorPalette.t1,
            },
            // defaultCardTemplateLink: {
            //     ...DefaultTheme.font.defaultCardTemplateLink,
            //     fontSize: 11,
            //     lineHeight: 10,
            //     fontFamily: fontPalette.bold,
            // },

            // ctaPrimaryText: {
            //     ...DefaultTheme.font.ctaPrimaryText,
            //     fontFamily: fontPalette.bold,
            // },
            // poweredByHeader: {
            //     ...DefaultTheme.font.poweredByHeader,
            //     color: colorPalette.white,
            // },
            // poweredBySubheader: {
            //     ...DefaultTheme.font.poweredBySubheader,
            //     color: colorPalette.white,
            // },
            // sharePollTitle: {
            //     ...DefaultTheme.font.sharePollTitle,
            //     fontSize: 24,
            //     lineHeight: 30,
            //     fontFamily: fontPalette.bold,
            // },
            // createPollTitleWeb: {
            //     ...DefaultTheme.font.createPollTitleWeb,
            //     fontFamily: fontPalette.bold,
            //     fontSize: 24,
            //     lineHeight: 30,
            //     color: colorPalette.primaryText,
            // },

            // //Transcript View

            previewImagePollTitle: {
                ...DefaultTheme.font.previewImagePollTitle,
                color: colorPalette.t1,
                fontFamily: fontPalette.bold,
                fontSize: 42,
                lineHeight: 51,
            },
            previewImageOptionTitle: {
                ...DefaultTheme.font.previewImageOptionTitle,
                fontFamily: fontPalette.bold,
                color: colorPalette.t1,
                fontSize: 35,
                lineHeight: 40,
            },
            previewImageOptionSubtitle: {
                ...DefaultTheme.font.previewImageOptionSubtitle,
                fontFamily: fontPalette.semiBold,
                color: colorPalette.flag,
                fontSize: 28,
                lineHeight: 34,
            },
            previewImageVotesCountText: {
                ...DefaultTheme.font.previewImageVotesCountText,
                fontFamily: fontPalette.semiBold,
                color: colorPalette.t1,
                fontSize: 24,
                lineHeight: 24,
            },

            // //Step 2 Controls

            // step2OptionsSelectedCounterValid: {
            //     ...DefaultTheme.font.step2OptionsSelectedCounterValid,
            //     fontFamily: fontPalette.semiBold,
            //     color: colorPalette.secondary,
            //     fontSize: 36,
            //     lineHeight: 36,
            // },
            // step2OptionsSelectedCounterInvalid: {
            //     ...DefaultTheme.font.step2OptionsSelectedCounterInvalid,
            //     fontFamily: fontPalette.semiBold,
            //     color: colorPalette.red,
            //     fontSize: 36,
            //     lineHeight: 36,
            // },
            step2OptionsCounterText: {
                ...DefaultTheme.font.step2OptionsCounterText,
                fontFamily: fontPalette.semiBold,
                color: colorPalette.t1,
                fontSize: 14,
                lineHeight: 14,
            },
            // step2FilterAll: {
            //     ...DefaultTheme.font.step2FilterAll,
            //     fontFamily: fontPalette.semiBold,
            //     color: colorPalette.blue,
            //     fontSize: 14,
            //     lineHeight: 14,
            // },
            // step2FilterNone: {
            //     ...DefaultTheme.font.step2FilterNone,
            //     fontFamily: fontPalette.semiBold,
            //     color: colorPalette.blue,
            //     fontSize: 14,
            //     lineHeight: 14,
            // },

            // //Step 2 Banner

            // pollListCopyBannerTitle: {
            //     ...DefaultTheme.font.pollListCopyBannerTitle,
            //     fontFamily: fontPalette.bold,
            //     color: colorPalette.primary,
            //     fontSize: 16,
            //     lineHeight: 16,
            // },
            // pollListCopyBannerSubtitle: {
            //     ...DefaultTheme.font.pollListCopyBannerSubtitle,
            //     fontFamily: fontPalette.semiBold,
            //     color: colorPalette.textColor,
            //     fontSize: 12,
            //     lineHeight: 12,
            // },

            // //Step 2 Option Card

            optionCardLinkTitle: {
                ...DefaultTheme.font.optionCardLinkTitle,
                fontFamily: fontPalette.semiBold,
                fontSize: 12,
                lineHeight: 16,
                color: colorPalette.t1,
            },

            optionCardLinkSubtitle: {
                ...DefaultTheme.font.optionCardLinkTitle,
                fontFamily: fontPalette.semiBold,
                fontSize: 11,
                lineHeight: 11,
                color: colorPalette.flag,
            },

            // dark mode tooltip for don't forget to submit your vote

            toolTipSubmitTitleText: {
                ...DefaultTheme.font.toolTipSubmitTitleText,
                fontFamily: fontPalette.bold,
                color: colorPalette.t1,
                fontSize: 30,
                lineHeight: 36,
            },
            toolTipSubmitSubtitleText: {
                ...DefaultTheme.font.toolTipSubmitSubtitleText,
                fontFamily: fontPalette.regular,
                color: colorPalette.t2,
                fontSize: 18,
                lineHeight: 22,
            },

            // QR

            sharePollScanTitle: {
                ...DefaultTheme.font.sharePollScanTitle,
                fontFamily: fontPalette.bold,
                color: colorPalette.t1,
                fontSize: 17,
                lineHeight: 18,
            },
            sharePollScanDescription: {
                ...DefaultTheme.font.sharePollScanDescription,
                fontFamily: fontPalette.regular,
                color: colorPalette.t2,
                fontSize: 15,
                lineHeight:16,
            },



        },

        image: {
            appLogo: require("../images/headerLogo.png"), // top left corner of desktop
            appBackgroundDesktop: `url(${EncodedImages.background})`,
            previewImageLogo: EncodedImages.logo, // top left of preview image
            previewImageCard: require("@assets/images/preview-image/cardDark.png"),
            previewImageBackground: require("../images/previewImageBackground.png"),
            //postVotePromo: require("../images/promo.png"),
            rememberSubmit: EncodedImages.rememberSubmit,
            rememberSubmitBackground: EncodedImages.rememberSubmitBackground,
        },

        lottie: {
            checkmark: require("../lottie/checkmark.json"),
            //     checkmarkDone: require("../lottie/checkmark_green.json"),
            //     whiteSpinner: require("../lottie/WhiteLoadingSpinner.json"),
            spinner: require("../lottie/spinner.json"),
            //     trashCan: require("../lottie/trashCan.json"),
            checkBox: require("../lottie/checkBox.json"),
            createPollSuccess: require("../lottie/createPollSuccess.json"),
        },
    },
})

export const getThemeByQueryParam = (queryParam: string): Theme => {
    return TenantTheme
}
